import { Component, OnInit, AfterViewInit, Input, ViewChild } from '@angular/core';
// import { GlobalService } from '../../../services/global.service';
// import { MessageService } from '../../../services/message.service';
// import { GraphService } from '../../../services/graphs.service';
// import { Observable } from 'rxjs';
// import { ConfigModel } from 'src/app/models/graphs.model';
// import { WellsModel } from 'src/app/models/wells.model';
// import { Location, ViewportScroller } from '@angular/common';
// import { filter } from 'rxjs/operators';
// import { Router, Scroll } from '@angular/router';

@Component({
    selector: 'app-ehs-injury-free-days',
    templateUrl: './injuryFreeDays.component.html',
    styleUrls: ['../../home/home.component.scss'],
})
export class InjuryFreeDaysComponent {

    ehsActualHarm_highlights: string = "";
    
    @Input() ehs_InjuryDays_TextPerformance: string;
    @Input() ehs_InjuryDays_TextExplanation: string;
    @Input() ehs_InjuryDays_Value: number;

    constructor() {}        

    // ngOnInit(): void {
    // }

    // ngOnDestroy(event) {
    // } 

    // ngAfterViewInit(): void {
    //     setTimeout(() => {
    //         this.refresh();
    //     })
    // }

    // refresh(): void {
    // }
    
}